import { useCallback, useRef } from 'react'
import { showToast } from 'common/ToastMessage'
import { FailedToastMessage, FailedToastMessageWithTryAgainContainer } from './FailedToastMessage'
import { MessageType } from 'antd/lib/message'
import { GenerateRequest } from 'types'
import { useQueryClient } from 'react-query'
import { EditorView } from 'prosemirror-view'

interface Props {
  view?: EditorView
}
export const useShowFailedGenerateRequestToast = (props?: Props) => {
  const toastRef = useRef<MessageType | null>(null)
  const dismissToast = useCallback(() => toastRef.current?.(), [])
  const queryClient = useQueryClient()

  return useCallback(
    (request: GenerateRequest) => {
      if ('article_id' in request && 'layer_id' in request && props?.view) {
        toastRef.current = showToast(
          <FailedToastMessageWithTryAgainContainer
            view={props.view}
            queryClient={queryClient}
            onClickOutside={dismissToast}
            request={request as Required<GenerateRequest>}
          />,
          0,
        )
        return
      }
      toastRef.current = showToast(<FailedToastMessage onClickOutside={dismissToast} />, 0)
    },
    [dismissToast, queryClient, props?.view],
  )
}
